(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-connection-demo]').forEach(section => {
      if (section.dataset.connectionReady) return;
      section.dataset.connectionReady = 'true';
      const video = section.querySelector('[data-connection-video]');
      const toggle = section.querySelector('[data-connection-toggle]');
      const caption = section.querySelector('[data-connection-caption]');
      const controls = section.querySelector('[data-connection-controls]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let interacted = false;
      let autoStarted = false;
      const sync = () => {
        caption.textContent = video.currentTime < 4.64 ? caption.dataset.positionCaption : caption.dataset.releaseCaption;
        toggle.textContent = video.ended ? toggle.dataset.replayLabel : video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      };
      const play = () => {
        if (video.ended) video.currentTime = 0;
        video.play().catch(sync);
      };
      toggle.addEventListener('click', () => {
        interacted = true;
        if (video.paused) play();
        else video.pause();
      });
      ['timeupdate', 'play', 'pause', 'ended', 'seeked'].forEach(event => video.addEventListener(event, sync));
      video.addEventListener('error', () => {
        video.controls = true;
        controls.hidden = true;
      });
      video.controls = false;
      controls.hidden = false;
      sync();
      reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) video.pause();
            else if (!autoStarted && !interacted && !reduced.matches) {
              autoStarted = true;
              play();
            }
          });
        }, { threshold: 0.5 });
        observer.observe(video);
      }
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
